import React, { useEffect, useMemo, useState } from 'react';
import { Card, Table, Tag, Form, Select, DatePicker, Button, Space, message } from 'antd';
import dayjs from 'dayjs';
import api from '../../services/api';

const STATUS_OPTIONS = [
  { value: 'AGUARDANDO_PAGAMENTO', label: 'Aguardando Pagamento' },
  { value: 'ATIVA', label: 'Ativa' },
  { value: 'TRANSFERIDA', label: 'Transferida' },
  { value: 'CONCLUIDA', label: 'Concluída' },
  { value: 'CANCELADA', label: 'Cancelada' },
];

export default function ListaMatriculasCrechePage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function init() {
      try {
        const [gruposRes, matsRes] = await Promise.all([
          api.get('/creche/grupos'),
          api.get('/creche/matriculas'),
        ]);
        setGrupos(gruposRes.data || []);
        setData(matsRes.data || []);
      } catch (e) {
        message.error('Erro ao carregar matrículas');
      }
    }
    init();
  }, []);

  const buscar = async () => {
    try {
      setLoading(true);
      const values = form.getFieldsValue();
      const params = {};
      if (values.status) params.status = values.status;
      if (values.grupoId) params.grupoId = values.grupoId;
      if (values.dataInicio) params.dataInicio = values.dataInicio.format('YYYY-MM-DD');
      const res = await api.get('/creche/matriculas', { params });
      setData(res.data || []);
    } catch (e) {
      message.error('Erro ao filtrar');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/creche/matriculas/${id}`, { status });
      message.success('Estado atualizado');
      await buscar();
    } catch (e) {
      message.error('Falha ao atualizar estado');
    }
  };

  const columns = useMemo(() => [
  { title: 'ID', dataIndex: 'id', width: 80 },
  { 
    title: 'Estudante', 
    dataIndex: 'estudanteNome',
    render: (nome, record) => (
      <div>
        <div style={{ fontWeight: 500 }}>{nome || `ID: ${record.estudanteId}`}</div>
        {record.responsavel && (
          <div style={{ fontSize: '12px', color: '#666' }}>
            Resp: {record.responsavel.nome}
          </div>
        )}
      </div>
    )
  },
  { title: 'Grupo', dataIndex: ['grupo', 'nome'] },
  { title: 'Início', dataIndex: 'dataInicio', render: v => v ? dayjs(v).format('DD/MM/YYYY') : '-' },
  { title: 'Estado', dataIndex: 'status', render: s => {
      const color = s === 'ATIVA' ? 'green' : s === 'AGUARDANDO_PAGAMENTO' ? 'orange' : 'default';
      return <Tag color={color}>{s}</Tag>;
    }
  },
  {
    title: 'Ações',
    render: (_, r) => (
      <Space>
        <Button size="small" onClick={() => updateStatus(r.id, 'ATIVA')}>Ativar</Button>
        <Button size="small" onClick={() => updateStatus(r.id, 'CONCLUIDA')}>Concluir</Button>
        <Button size="small" danger onClick={() => updateStatus(r.id, 'CANCELADA')}>Cancelar</Button>
      </Space>
    )
  }
], []);


  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <Card title="Matrículas da Creche">
        <Form layout="inline" form={form} className="mb-4">
          <Form.Item name="status" label="Estado">
            <Select allowClear style={{ minWidth: 220 }} options={STATUS_OPTIONS} />
          </Form.Item>
          <Form.Item name="grupoId" label="Grupo">
            <Select
              allowClear
              style={{ minWidth: 220 }}
              options={(grupos || []).map(g => ({ value: g.id, label: g.nome }))}
            />
          </Form.Item>
          <Form.Item name="dataInicio" label="Data Início">
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={buscar} loading={loading}>Filtrar</Button>
          </Form.Item>
        </Form>

        <Table rowKey="id" dataSource={data} columns={columns} loading={loading} />
      </Card>
    </div>
  );
}
